<template>
  <div id="app">
    <div class="admin-box" v-if="$store.state.adminInfo && $store.state.adminInfo.id">
      <NavHeaderComponent />
      <NavMenuComponent>
        <template slot="content">
          <router-view />
        </template>
      </NavMenuComponent>
    </div>
    <router-view v-if="$store.state.adminInfo && !$store.state.adminInfo.id" />
  </div>
</template>

<script>
import {post} from './utils/RequestUtil'
import NavHeaderComponent from './components/NavHeaderComponent'
import NavMenuComponent from './components/NavMenuComponent'

export default {
  name: 'App',
  components: {
    NavMenuComponent,
    NavHeaderComponent
  },
  mounted () {
    this.initUserInfo()
  },
  data () {
    return {
      title: ''
    }
  },
  methods: {
    initUserInfo () {
      post('/admin/info').then((response) => {
        this.$store.commit('updateAdminInfo', response)
      })
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  font-size: 13px;
  width: 100%;
  height: 100%;

  h2 {
    font-size: 18px;
    text-align: center;
    margin-top: 10px;
  }

  .admin-box {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue